import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import CampaignForm, { campaignToForm, useCampaignFormSubmit } from '../../components/admin/CampaignForm';
import { fetchAdminPvpCampaign, finalizeAdminPvpCampaign } from '../../lib/pvpCampaignApi';
import { PageTitle, Card, Btn, BtnRow, BtnDanger, ErrorText } from '../../styles/adminStyles';
import { usePortalT } from '../../i18n/usePortalT';

export default function CampaignEditPage() {
  const { id } = useParams();
  const { t } = usePortalT();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [ending, setEnding] = useState(false);
  const { submit, saving, error } = useCampaignFormSubmit({
    form: form || {},
    campaignId: id,
    isEdit: true,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const c = await fetchAdminPvpCampaign(id);
        if (!cancelled) setForm(campaignToForm(c));
      } catch (e) {
        if (!cancelled) setLoadError(e instanceof Error ? e.message : 'Load failed');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  const handleEnd = async () => {
    if (!window.confirm(t('campaigns.confirmEndExport'))) return;
    setEnding(true);
    const out = await finalizeAdminPvpCampaign(id);
    setEnding(false);
    if (!out.success) {
      alert(out.error || t('campaigns.endFailed'));
      return;
    }
    window.location.href = `/admin/campaigns/${id}`;
  };

  if (loading) return <p>{t('common.loading')}</p>;
  if (loadError) return <ErrorText>{loadError}</ErrorText>;
  if (!form) return null;

  return (
    <div>
      <PageTitle>{t('campaigns.editTitle')}</PageTitle>
      <Card>
        <CampaignForm form={form} onChange={setForm} isEdit />
        {error ? <ErrorText>{error}</ErrorText> : null}
        <BtnRow>
          <Btn $primary type="button" disabled={saving} onClick={() => void submit()}>
            {saving ? t('common.saving') : t('common.save')}
          </Btn>
          <Link to={`/admin/campaigns/${id}`}><Btn type="button">{t('campaigns.backToDetail')}</Btn></Link>
          {form.status !== 'ended' ? (
            <BtnDanger type="button" disabled={ending} onClick={() => void handleEnd()}>
              {ending ? t('common.processing') : t('campaigns.endEvent')}
            </BtnDanger>
          ) : null}
        </BtnRow>
      </Card>
    </div>
  );
}
